/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandInertia = createReactComponent("outline", "brand-inertia", "IconBrandInertia", [["path", { "d": "M12.5 8l4 4l-4 4h4.5l4 -4l-4 -4z", "key": "svg-0" }], ["path", { "d": "M3.5 8l4 4l-4 4h4.5l4 -4l-4 -4z", "key": "svg-1" }]]);

export { IconBrandInertia as default };
//# sourceMappingURL=IconBrandInertia.mjs.map
